export default "__VITE_ASSET__CXxoAHYT__"